<!-- desktop -->
<div *ngIf="isDesktop" class="container">
    <hr class="display-at-bottom-fixed">
</div>

<!-- mobile -->
<div *ngIf="!isDesktop" class="container"></div>
